
import DriversBfixSelect from '@/components/dashBoard/selectsFields/components/DriversSelect/DriverBfixSelect.vue';
import DatePicker from '@/components/searchPage/DatePicker.vue';
import store from '@/store';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import DateSelect from './components/DateSelect/DateSelect.vue';
import DriversSelect from './components/DriversSelect/DriversSelect.vue';
import StateSelect from './components/StateSelect/StateSelect.vue';
import { User } from '@/models/main';
import { timeZoneDefault } from '@/utils/PortalConstants';
import { format, utcToZonedTime } from 'date-fns-tz';
import { addDays } from 'date-fns';

@Component({
  components: {
    DatePicker,
    DateSelect,
    StateSelect,
    DriversSelect,
    DriversBfixSelect,
  },
  computed: {
    ...mapState(['storeSearch']),
    ...mapState('moduleUser', { user: 'user', userSelectedDates: 'userSelectedDates' }),
  },
})
export default class SelectFields extends Vue {
  @Prop({ type: String, default: '' }) private readonly context: string;

  private user!: User;
  private userSelectedDates!: string[];
  private dates: string[] = [];

  private search = '';
  private storeSearch!: string;
  @Watch('search')
  private setSearch() {
    store.dispatch('setSearch', this.search);
  }
  private changeDate(dates): void {
    this.dates = dates;
    this.$emit('changeDate', dates);
  }
  private clearDateFilter() {
    this.dates = [];
  }
  private mounted() {
    const userTimeZone = this.user.timezone || timeZoneDefault;
    const today = format(utcToZonedTime(new Date(), userTimeZone), 'yyyy-MM-dd');
    if (this.context === 'bfix') {
      const dayAfterOneWeek = format(utcToZonedTime(addDays(new Date(), 6), userTimeZone), 'yyyy-MM-dd');
      this.userSelectedDates.length === 2
        ? (this.dates = this.userSelectedDates)
        : (this.dates = [today, dayAfterOneWeek]);
    } else {
      this.userSelectedDates.length === 1 ? (this.dates = this.userSelectedDates) : (this.dates = [today]);
    }
    store.dispatch('moduleUser/setUserDates', this.dates);
    this.search = this.storeSearch;
  }
}
